export default function textCleanerTags(text){
	return text.replace(/<\/?[^>]+(>|$)/g, "")
}